import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import './Grid.module.css';

class Cell extends PureComponent {
  render() {
    const {
      overallSize,
      smallSize,
      mediumSize,
      largeSize,
      smallOffset,
      mediumOffset,
      largeOffset,
      smallOrder,
      mediumOrder,
      largeOrder,
      secondaryAlignment,
      children,
      classes,
      className,
      styles,
      overlap,
      backgroundColor,
      backgroundImage,
      contentAlignment
    } = this.props;
    const styleNames = [];
    if (overallSize) {
      styleNames.push(overallSize);
    } else {
      if (smallSize) {
        styleNames.push(`small-${smallSize}`);
      }
      if (mediumSize) {
        styleNames.push(`medium-${mediumSize}`);
      }
      if (largeSize) {
        styleNames.push(`large-${largeSize}`);
      }
    }

    const order = {
      [`small-order-${smallOrder}`]: smallOrder,
      [`medium-order-${mediumOrder}`]: mediumOrder,
      [`large-order-${largeOrder}`]: largeOrder
    };

    const styling = {
      cell: true,
      [`overlap-${overlap}`]: overlap,
      [`overlap`]: overlap,
      [`small-offset-${smallOffset}`]: smallOffset,
      [`medium-offset-${mediumOffset}`]: mediumOffset,
      [`large-offset-${largeOffset}`]: largeOffset,
      [`${secondaryAlignment}`]: secondaryAlignment,
      [`${contentAlignment}`]: contentAlignment,
      [`${backgroundColor}`]: backgroundColor
    };
    const bgImg = backgroundImage
      ? {
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }
      : {};
    return (
      <div
        className={classNames(className, classes)}
        style={{ ...styles, ...bgImg }}
        styleName={classNames(styling, styleNames, order)}
      >
        {children}
      </div>
    );
  }
}

Cell.propTypes = {
  /** The overall size of this cell. This will override all breakpoint sizes and offsets. */
  overallSize: PropTypes.oneOf(['shrink', 'auto']),
  /** The small breakpoint width. */
  smallSize: PropTypes.oneOf([
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    'auto',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24
  ]),
  /** The medium breakpoint width. */
  mediumSize: PropTypes.oneOf([
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    'auto',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24
  ]),
  /** The large breakpoint width. */
  largeSize: PropTypes.oneOf([
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    'auto',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24
  ]),
  /** The small breakpoint offset. */
  smallOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** The medium breakpoint offset. */
  mediumOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** The large breakpoint offset. */
  largeOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Secondary alignment for this individual cell. */
  secondaryAlignment: PropTypes.oneOf([
    'align-self-top',
    'align-self-middle',
    'align-self-bottom'
  ]),
  smallOrder: PropTypes.oneOf([1, 2, 3, 4, 5, 6, '1', '2', '3', '4', '5', '6']),
  mediumOrder: PropTypes.oneOf([
    1,
    2,
    3,
    4,
    5,
    6,
    '1',
    '2',
    '3',
    '4',
    '5',
    '6'
  ]),
  largeOrder: PropTypes.oneOf([1, 2, 3, 4, 5, 6, '1', '2', '3', '4', '5', '6']),
  children: PropTypes.node,
  classes: PropTypes.any,
  styles: PropTypes.object,
  overlap: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
  contentAlignment: PropTypes.string
};

export default DisplayComponent(Cell);
